var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("ul", { staticClass: "nav nav-pills" }, [
              _vm.ewbTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/ewb-config"
                          }
                        },
                        [_vm._v("Config")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { "active-class": "active", to: "/admin/users" }
                    },
                    [_vm._v("Users")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "active-class": "active",
                        to: "/admin/credentials"
                      }
                    },
                    [_vm._v("EWaybill Credentials")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.podTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/contact"
                          }
                        },
                        [_vm._v("Contact")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "active-class": "active",
                        to: "/admin/customers"
                      }
                    },
                    [_vm._v("Customers")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.ewbTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/vendors"
                          }
                        },
                        [_vm._v("Vendors")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.podTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/locations"
                          }
                        },
                        [_vm._v("Warehouses")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "active-class": "active",
                        to: "/admin/transporters"
                      }
                    },
                    [_vm._v("Transporters")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.podTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/config"
                          }
                        },
                        [_vm._v("Configuration")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.podTenant
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "active-class": "active",
                            to: "/admin/debug"
                          }
                        },
                        [_vm._v("API Debug")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d7db904", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7db904","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminPage.vue
// module id = null
// module chunks = 